<script lang="ts">
  // components
  import DetailBody from "@retailer/svelte/Payments/Credits/components/DetailBody.svelte";
  import Payment from "@retailer/svelte/Payments/Credits/components/Payment.svelte";

  // stores
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";
  import { creditsStore } from "@retailer/stores/CreditsStore";

  // reactives
  $: dataFetched = !!$InvoiceStore.invoice && !!$creditsStore.loaded.redemptions;

</script>

{#if dataFetched}
  <div
    class="fizz-hide-on-small fizz-layout-invoice fizz-flex-row fizz-justify-center fizz-inset-square-16"
  >
    <div class="fizz-bordered" style="align-self: start">
      <DetailBody invoice={$InvoiceStore.invoice} />
    </div>
    <div class="fizz-hide-on-small" style="align-self: start;">
      <div class="fizz-bordered">
        <Payment />
      </div>
    </div>
  </div>

  <div
    class="fizz-layout-invoice fizz-hide-on-large fizz-flex-column fizz-justify-center fizz-inset-square-16"
  >
    <div class="">
      <div class="fizz-bordered">
        <Payment />
      </div>
    </div>
    <div class="fizz-bordered" style="align-self: start">
      <DetailBody invoice={$InvoiceStore.invoice} />
    </div>
  </div>
{:else}
  <main data-grid-area="main">
    <div class="fizz-container fizz-grid-center">
      <div class="fizz-icon-spinner" style={"margin-top: 25vh"} />
    </div>
  </main>
{/if}
